import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { LocationService } from '@shared';

/**
 * Location guard that requires user to have selected a delivery location
 * Redirects to location page if no location is selected
 */
export const locationGuard: CanActivateFn = async (route, state): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const locationService = inject(LocationService);

  const location = locationService.location();
  
  // Check if location is selected and has coordinates
  if (!location || !location.coordinates) {
    // Redirect to location page
    return router.createUrlTree(['/location'], { 
      queryParams: { returnUrl: state.url } 
    });
  }

  // Location is selected - allow access
  return true;
};

